export default "__VITE_ASSET__B$clGiel__"